import * as React from 'react';
import * as _ from 'underscore';

import { SpaceInfo, SpaceItemForNonEntitySpace } from '../../state/SpaceInfo';

import { AdminSiteStatus } from '../../../serverStatus/components/AdminSiteStatus';
import { AppState } from '../../state/AppState';
import { ConnectedSpaceInfoProvider } from '../RouterHelpers/SpaceInfoProvider';
import { MapStateToProps } from '../../utils/ConnectUtils';
import { RouterError } from '../RouterHelpers/RouterError';
import { SessionServerSelectors } from '../../selectors/SessionInfoSelectors';
import { SpacesSiteUrls } from '../SpacesSiteUrls';
import { connect } from 'react-redux';

export interface SiteStatusSpaceProviderOwnProps {
  readonly siteName: string;
  readonly urls: SpacesSiteUrls;
}

export interface SiteStatusSpaceProviderStateProps {
  readonly isAdminViewsEnabled: boolean;
}

export type SiteStatusSpaceProviderComponentProps = SiteStatusSpaceProviderOwnProps & SiteStatusSpaceProviderStateProps;

export class SiteStatusSpaceProviderComponent extends React.PureComponent<SiteStatusSpaceProviderComponentProps> {

  public render() {
    if (this.props.isAdminViewsEnabled) {
      return this.renderSubSpace();
    } else {
      return <RouterError errorType={'default'} urls={this.props.urls} />;
    }
  }

  private renderSubSpace = () => {
    return (
      <div>
        {
          <AdminSiteStatus
            siteName={this.props.siteName}
          />
        }
      </div>
    );
  }

}

const mapStateToProps: MapStateToProps<SiteStatusSpaceProviderStateProps> = (appState: AppState) => ({
  isAdminViewsEnabled: SessionServerSelectors.isAdminViewsEnabled(appState)
});

export const ConnectedSiteStatusSpaceProviderComponent: React.ComponentClass<SiteStatusSpaceProviderOwnProps>
  = connect(mapStateToProps, undefined)(SiteStatusSpaceProviderComponent);

export type SiteStatusSpaceProviderProps = SiteStatusSpaceProviderOwnProps;

const SiteStatusSpaceInfo: SpaceInfo = {
  item: SpaceItemForNonEntitySpace,
  spaceType: 'sitestatus',
  subspaceName: undefined
};

export function SiteStatusSpaceProvider(props: SiteStatusSpaceProviderProps) {
  return (
    <ConnectedSpaceInfoProvider spaceInfo={SiteStatusSpaceInfo}>
      <ConnectedSiteStatusSpaceProviderComponent {...props} />
    </ConnectedSpaceInfoProvider>
  );
}
